import React from "react";
import styled from "styled-components";
import { colors } from "../../../utils/theme";
import { useNavigate } from "react-router-dom";
import { useDataContex } from "../../../hooks/Context/PatientProvider";

import {
  IPatientContinuidad,
  Order,
  IPatientInfo,
} from "../../../interfaces/Patient";

const Container = styled.div`
  width: 100%;
  .form {
    border-bottom: 1px solid #00000029;
    padding: 1rem 0;
    width: 95%;
    margin: 0 auto;
  }
`;

const ContainerFormInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;
const FormInputInfo = styled.div`
  width: 25%;
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (max-width: 1440px) {
    width: 30%;
  }
  @media (max-width: 768px) {
    width: 45%;
  }
  @media (max-width: 500px) {
    width: 90%;
  }

  label {
    width: 100%;
    color: ${colors.third};
    font-weight: 600;
    @media (max-width: 1024px) {
      text-align: start;
    }
  }

  input {
    width: 80%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  .button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    @media (max-width: 1440px) {
      width: 30%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

const OrderMapContinuity = ({ data }: { data: IPatientInfo | null }) => {
  const patient = {
    name: data?.name,
    email: data?.email,
    numeroDocumento: data?.numeroDocumento,
    telefono: data?.telefono,
    fechaNacimiento: data?.fechaNacimiento,
  };
  return (
    <Container>
      {data?.orders.map((order, index) => (
        <SingleOrderForm key={index} order={order} patient={patient} />
      ))}
    </Container>
  );
};

const SingleOrderForm = ({ order, patient }) => {
  const { setData2, data, setHorariosData, setPatientContinuidadContex } = useDataContex();
  const navigate = useNavigate();
  if (!order || !patient) {
    navigate("/Continuidad");
  }
  const handleInputChange = (newValue) => {
    console.log("");
  };

  const handleViewSessions = (e, order: Order, patient) => {
    e.preventDefault();
    const PatientOrderSession: IPatientContinuidad = {
      name: patient.name,
      numeroDocumento: patient.numeroDocumento,
      fechaNacimiento: patient.fechaNacimiento,
      tipoDocumento: patient.tipoDocumento, 
      email: patient.email,
      telefono: patient.telefono,
      orders: order,
    };
    setPatientContinuidadContex(PatientOrderSession);
    async function postHorariosDisponibles(areaAfectada, fromDate, toDate) {
      const url =
        "/apihub/legacy/Service/Agenda/HorariosDisponibles";
      const requestBody = {
        areaAfectada: areaAfectada,
        fromDate: fromDate,
        toDate: toDate,
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error en la solicitud POST:", error);
      }
    }

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const fromDate = formattedDate.substring(0, 10);
    const fromTo = new Date(fromDate);
    fromTo.setDate(fromTo.getDate() + 15);
    const toDate = fromTo.toISOString().split("T")[0];
    postHorariosDisponibles("MUÑECA Y MANO", fromDate, toDate)
      .then((data) => {

        setHorariosData(data);
      })
      .catch((error) => console.error(error));

    navigate("/SesionProgramada");
  };
  return (
    <form
      className="form"
      onSubmit={(e) => handleViewSessions(e, order, patient)}
    >
      <ContainerFormInfo>
        <FormInputInfo>
          <label>ÁREA AFECTADA</label>
          <input
            type="text"
            value={order.areaAfectada}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>NO. DE ORDEN</label>
          <input
            type="text"
            value={order.numeroDeOrden}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
        <FormInputInfo>
          <label>AUTORIZACIÓN</label>
          <input
            type="text"
            value={order.autorizacion}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>SESIONES AUTORIZADAS</label>
          <input
            type="text"
            value={order.sesionesAutorizadas}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
        <FormInputInfo>
          <label>SESIONES REALIZADAS</label>
          <input
            type="text"
            value={order.sesionesRealizadas}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>ENTIDAD</label>
          <input
            type="text"
            value={order.entidad}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>MÉDICO REMITENTE</label>
          <input
            type="text"
            value={order.medicoRemitente}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>FECHA</label>
          <input
            type="text"
            value={order.fechaInicioTratamiento}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
      </ContainerFormInfo>
      <ContainerButton>
        <button className="button" type="submit">
          AGENDA TU CITA
        </button>
      </ContainerButton>
    </form>
  );
};

export default OrderMapContinuity;
